import { DocumentationValidationStatusEnum } from 'graphql-common';
import { ChipTypes } from '@lib/components/Chip/Chip';
import getValidationStatusOptions from './getValidationStatusOptions';

export default function getValidationStatusChipType(
  status: DocumentationValidationStatusEnum | null | undefined,
) {
  if (!status) return ChipTypes.chipDisabled;
  const options = getValidationStatusOptions();
  const option = options.find((o) => o.value === status);
  return option?.color || ChipTypes.chipDisabled;
}
